goog.provide('el8.practicedata.medOrderTemplates');

goog.require('el8.model.base');
goog.require('el8.service.urls');

el8.practicedata.medOrderTemplates = (function() {
    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makeSortable();
    _class.makeDeleteable();

    _class.addStringProperty('name');
    _class.addIntProperty('medicationId', true);
    _class.addStringProperty('directions', true);
    _class.addStringProperty('qtyUnits', true);
    _class.addIntProperty('qty', true);
    _class.addIntProperty('authRefills', true);

    var that = new el8_EntitySet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('medOrderTemplates'); },
        urlFn: function(id) { return el8.service.url.get('medOrderTemplates', [id]); },
        urlSort: function() { return el8.service.urls.get('sortMedOrderTemplates'); },
        saveFn: function(item, successCb, errorCb, opts) {
            var data = item.asMap(true);
            if (item.getId()) {
                // serializing data to match server route's template.update(**data) for updates
                data['medication'] = data['medication_id'];
                delete data['medication_id'];
            }

            $.el8_ajax({
                type: 'POST',
                url: el8.service.urls.get('medOrderTemplates', [item.getId()]),
                data: JSON.stringify(data), // true to serialize with underscores
                success: function(data) {
                    item.populate(data);
                    if (successCb) {
                        successCb();
                        el8.appservice.notifier.notify('Rx template saved.');
                    }
                },
                error_override: function(data) {
                    if (data.status === 409) {
                        el8.uiwidget.alert('This Rx template already exists.');
                    } else {
                        el8.uiwidget.alert(el8.util.consts.DEFAULT_ERROR_MSG);
                    }
                }
            });
        },
        deleteFn: function(item, successCb, errorCb, opts) {
            $.el8_ajax({
                type: 'DELETE',
                url: el8.service.urls.get('medOrderTemplates', [item.getId()]),
                success: successCb,
                error: errorCb
            });
        }
    });
    that.makeSetSortable();

    return that;
})();
